import { render, staticRenderFns } from "./PromotionBidPopup.vue?vue&type=template&id=841d1674&"
import script from "./PromotionBidPopup.vue?vue&type=script&lang=js&"
export * from "./PromotionBidPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports